import React from "react";

const LoadingComponent = () => (
    <div id="loading-component">
        <div className="loader"></div>
    </div>
);

export default LoadingComponent;
